<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <h1 class="text-center title">Pour aller plus loin</h1>
    <div class="page-containerp">
      <div class="page-area-new">
        <p>Les ressources ci-dessous comprennent des ressources supplémentaires en lien avec divers sujets ciblés. Chacune comporte un résumé des concepts du sujet, des questions de réflexion, des défis en lien avec le sujet ciblé ainsi que des informations supplémentaires sur le sujet.</p>
      </div>
    </div>
    <div class="page-containerp">
      <div class="page-area-new">
        <router-link class="row link" v-for="info in infos" :key="info.linkName" :to="{ name: info.linkName }">
          <div class="d-none d-md-block image-wrapper">
            <!-- .imageSrc .imageAlt -->
            <img :src="info.imageSrc" class="img-fluid corner-cutted" :alt="info.imageAlt" />
          </div>
          <div class="col d-flex align-items-center">
            <p class="h2">{{ info.titre }}</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
export default {
  components: {
    ProgressBars,
  },
  data() {
    return {
      infos: [
        {
          imageSrc: require("@/assets/fiches/apl1/AdobeStock_28006614.jpeg"),
          imageAlt: "",
          titre: "Les relations authentiques",
          linkName: "pourAllerPlusLoin1",
        },
        {
          imageSrc: require("@/assets/fiches/apl2/AdobeStock_177065225.jpeg"),
          imageAlt: "",
          titre: "L’apprentissage par l’exploration, le jeu et l’enquête",
          linkName: "pourAllerPlusLoin2",
        },
        {
          imageSrc: require("@/assets/fiches/apl3/AdobeStock_265143893.jpeg"),
          imageAlt: "",
          titre: "L’environnement comme troisième éducateur",
          linkName: "pourAllerPlusLoin3",
        },
        {
          imageSrc: require("@/assets/fiches/apl4/AdobeStock_277586010.jpeg"),
          imageAlt: "",
          titre: "L’engagement familial",
          linkName: "pourAllerPlusLoin4",
        },
      ],
    };
  },
};
</script>

<style scoped>
h1.title {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "Poppins";
  color: #333;
}
.h2 {
  font-size: 1.35rem !important;
  color: #000;
  font-weight: 600;
}
.page-container {
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.page-area-new {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px 30px;
  margin-bottom: 20px;
}
.link {
  margin: 30px 0px;
  width: fit-content;
}
.link:hover p,
.link:focus p {
  text-decoration: underline;
}
@media (min-width: 1200px) {
  .link {
    width: 50%;
    display: inline-flex;
  }
}
.image-wrapper {
  width: 150px;
}
img.corner-cutted {
  border-radius: 15px;
}
</style>
